export function createNoopReducer<State>(): (state: State) => State;
export function createNoopReducer<State>(defaults: State | null): (state: State) => State;

export function createNoopReducer<State>(defaults: State | null = null) {
  const defaultState = defaults as State;

  return (state: State = defaultState) => state;
}
